/* eslint-disable */
import { createSelector } from 'reselect';
import ordersSelector from './Orders.selector';

/**
 * Select the order ids
 * @returns {OrderEntity | null} The `order` that has been selected from the store
 */
const orderIdsSelector = createSelector(ordersSelector, (orders) => orders.ids);

export default orderIdsSelector;
